<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', false)"
    header="Driver status overview"
    modal
  >
    <Message
      class="alert"
      v-if="error"
      severity="error"
      :closable="false"
      style="width: 50rem"
    >
      Driver statuses currently unavailable!
    </Message>

    <DataTable v-if="!error" :value="drivers" style="width: 50rem">
      <Column header="Status">
        <template #body="slotProps">
          <font-awesome-icon
            icon="circle"
            :style="{ color: getColorByStatus(slotProps.data.status) }"
          />
        </template>
      </Column>

      <Column
        v-for="field in fields"
        :key="field.key"
        :header="field.label"
        :field="field.key"
      >
      </Column>
    </DataTable>
  </Dialog>
</template>

<script lang="ts">
import Colors from '@/infrastructure/support/Colors.ts';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'DriverStatusDialog',
  components: { FontAwesomeIcon },
  props: {
    visible: { type: Boolean, required: true },
    drivers: { type: Array },
    error: { type: Boolean, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: 'driver',
          label: 'Driver',
        },
        {
          key: 'description',
          label: 'Description',
        },
      ],
    };
  },
  methods: {
    getColorByStatus(status) {
      if (status === 0) {
        return Colors.colorByStatus('OK');
      } else if (status === 1) {
        return Colors.colorByStatus('MEDIUM');
      } else if (status === 2) {
        return Colors.colorByStatus('NOK');
      } else {
        return Colors.colorByStatus('NONE');
      }
    },
  },
};
</script>
